<form [formGroup]="form" class="container">
  <app-titulo>Vinculação de Cavalo ou Carreta</app-titulo>
  <div class="inputs">
    <app-input
      type="text"
      label="Placa do Cavalo"
      name="TX_PLCA_CAVA"
      formControlName="TX_PLCA_CAVA"
      mask="AAA-0A00"
      placeholder="Digite aqui"></app-input>
    <app-input
      type="text"
      label="Placa da Carreta"
      name="TX_PLCA_CRRT"
      formControlName="TX_PLCA_CRRT"
      mask="AAA-0A00"
      placeholder="Digite aqui"></app-input>
  </div>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="postVinculacao()"
      [disabled]="isLoading" />
  </div>
</form>

<app-loader *ngIf="isLoading" />
